import { Component, OnInit, Input } from '@angular/core';
import { ApiService } from '../../api.service';
import * as moment from 'moment';

@Component({
  selector: 'app-bloc-game',
  templateUrl: './bloc-game.component.html',
  styleUrls: ['./bloc-game.component.scss']
})
export class BlocGameComponent implements OnInit {

  today = new Date();

  hoveredItem = false ;

  imgDialog = false;

  @Input('game') game:any;
  @Input() view:string = "gridView";
  @Input() preorder:string = "";

  constructor(public api:ApiService) { }

  ngOnInit(): void {
    if(this.game.ItemType == '1'){
      let find = this.api.ebpOffers.find(item => item.Id == this.game.Id);
      if(!find)
        this.game.orderable = false;
    }
    this.game.name_item = this.game.name_item.replace(/LOCALIZED VERSION/gi,"");
    this.game.name_item = this.game.name_item.replace(/LOCALIZED/gi,"");
    this.game.name = this.game.name_item;
  }

  refresh(){
    this.api.post("SPDO=select",{database:'favorite',where:"CustomerId = '"+this.api.user.Id+"'"}).then((res:any)=>{
      this.api.favs = res.data;
    });
  }

  setFavorite(){
    if(this.isFav()){
      this.api.post("SPDO=delete",{database:'favorite',where:{ItemId:this.game.Id,CustomerId:this.api.user.Id}}).then((res:any)=>{
        this.api.success("Supprimé de vos favoris.");
        this.refresh();
      });
    }else{
      this.api.post("SPDO=insert",{database:'favorite',data:{ItemId:this.game.Id,CustomerId:this.api.user.Id}}).then((res:any)=>{
        this.api.success("Ajouté à vos favoris.");
        this.refresh();
      });
    }
  }

  subscribeToReassort(event){
    if(!event.checked){
      this.api.post("SPDO=delete",{database:'reassort_subscription',where:{ItemId:this.game.Id,CustomerId:this.api.user.Id}}).then((res:any)=>{
      });
    }else{
      this.api.post("SPDO=insert",{database:'reassort_subscription',data:{ItemId:this.game.Id,CustomerId:this.api.user.Id}}).then((res:any)=>{
      });
    }
  }

  isFav(){
    if(this.api.favs && this.api.favs.findIndex(item=>item.ItemId == this.game.Id) > -1)
      return true;
    return false;
  }

  offer:any;
  imgDialogShow(e){
    let els = document.getElementsByClassName("imgDialogContent");
    if(els && els[0]){
      if(this.game.imgError === true){
        //els[0].children[0]['style'].display = 'none';
        els[0].children[0]['src'] = "https://blackrockgames.fr/upload/thumbd.php?id="+this.game.image_princ+"&id_item="+this.game.id_item+"&size=w1024h768";  
        //els[0].children[0]['style'].height = (window.innerHeight - 50)+'px';
        els[0].children[0]['style'].opacity = '1';
      }else{
        els[0].children[0]['style'].height = (els[0].clientHeight - 50)+'px';
        els[0].children[0]['style'].opacity = '1';
      }
    }
  }

  addOffer(Id){
    let offer = this.api.ebpOffers.find(item => item.Id == Id);
    if(offer){
      this.api.addEbpOffer(offer);
    }
  }
}
